import { render } from "./S272475.vue?vue&type=template&id=717f377c"
const script = {}
script.render = render

export default script